export function inBBox(lon, lat, b) {
    return lon >= b.west && lon <= b.east && lat >= b.south && lat <= b.north;
}
/**
 * Samler alt innenfor område + tidsrom til en pakke (deterministisk).
 *
 * ⚠ `observasjoner` FILTRERES IKKE, OG DET ER MED VILJE.
 * Spor, meldinger og intel hentes fra det LEVENDE situasjonsbildet, og der er
 * boks + tidsrom hele avgrensningen. Arkivutvalget er noe annet: det er et svar
 * på analytikerens egen spørring, som kan ha vært et nærhetssøk, et fritekstsøk
 * eller «alt som besvarer RFI-7». Ble det filtrert på nytt mot kartboksen, ville
 * pakken stille kastet observasjoner analytikeren nettopp valgte — og hun ville
 * ikke sett det, fordi tallet i `counts` også ville krympet. Utvalget følger med
 * som det er, og `meta.utvalg` sier hva det var.
 */
export function buildIntelPackage(p) {
    const inTime = (ts) => ts >= p.sinceMs && ts <= p.untilMs;
    const tracks = p.tracks.filter((t) => inTime(t.tsMs) && inBBox(t.lon, t.lat, p.bbox));
    const reports = p.reports.filter((r) => inTime(r.tsMs) && inBBox(r.lon, r.lat, p.bbox));
    // Intel uten geoposisjon tas med (gjelder ofte hele området); med posisjon
    // filtreres på bbox.
    const intel = p.intel.filter((i) => inTime(i.tsMs) && (i.lat === undefined || i.lon === undefined || inBBox(i.lon, i.lat, p.bbox)));
    const observasjoner = [...(p.observasjoner ?? [])];
    return {
        meta: {
            title: p.title,
            createdBy: p.createdBy,
            createdMs: p.createdMs,
            bbox: p.bbox,
            sinceMs: p.sinceMs,
            untilMs: p.untilMs,
            ...(p.utvalg ? { utvalg: p.utvalg } : {}),
            counts: {
                tracks: tracks.length,
                reports: reports.length,
                intel: intel.length,
                observasjoner: observasjoner.length,
            },
        },
        tracks,
        reports,
        intel,
        observasjoner,
    };
}
//# sourceMappingURL=intel-package.js.map